import { inject } from '@angular/core';
import { CanActivateFn, Router, ActivatedRouteSnapshot } from '@angular/router';
import { SessionProvider } from '../providers/session/session';
import { NavController } from '@ionic/angular';
import { TutorialProvider } from 'src/providers/tutorial/tutorial';

export const authGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const sessionService = inject(SessionProvider);
  const tutorialProvider = inject(TutorialProvider)
//   const router = inject(NavController);
    const router = inject(Router);
  if (sessionService.isLoged || !tutorialProvider.isLoginAllowed) {
    return true;
  }
  return router.parseUrl('/auth/login');
};
